import { useState, useMemo } from 'react'
import { Modal } from 'react-bootstrap'
import qs from 'qs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import Button, {
  ButtonSizes,
  ButtonType,
  ButtonVariant,
} from 'design-system/button'
import { SenceAPI, SENCE_LOGOUT_ERROR_URL, SENCE_LOGOUT_URL } from 'config'
import { IntegrationConfigSence, ISenceIntegration } from 'models/integrations'
import { useSearch } from 'hooks/react.hooks'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { FormCommon } from './FormCommon'
import { Types } from '../constants'

interface LogoutProps {
  data: ISenceIntegration
  loading: boolean
  params: IntegrationConfigSence
}

export const LogoutSence = ({ data, loading, params }: LogoutProps) => {
  const t = useTranslationRankmi({
    prefix: 'courses.show.sence',
  })
  const [{ errorCode, type }] = useSearch<'errorCode' | 'type'>()

  const error = type === Types.logout_error ? errorCode : null
  const [show, setShow] = useState(!!error)

  const to = useMemo(() => {
    const url = new URL(location.href)
    url.search = ''
    return url.toString()
  }, [])

  const senceLoginError = `${SENCE_LOGOUT_ERROR_URL}?${qs.stringify({
    to,
  })}`
  const senceLogoutSuccess = `${SENCE_LOGOUT_URL}?${qs.stringify({
    to,
  })}`

  const children = (
    <form action={SenceAPI.logOut} method="post">
      <FormCommon
        error={senceLoginError}
        success={senceLogoutSuccess}
        data={data}
        params={params}
      />
      <input
        type="hidden"
        value={params.session?.sessionSence}
        name="IdSesionSence"
      />
      <Button
        variant={ButtonVariant.Danger}
        size={ButtonSizes.Small}
        type={ButtonType.Submit}
        disabled={loading}
        className="m-0"
      >
        {t('logout.button')}
      </Button>
    </form>
  )

  return (
    <div>
      <Modal size="lg" show={show} centered onHide={() => setShow(false)}>
        <Modal.Header closeButton className="ml-3 mr-3 mt-2 pb-2">
          <Modal.Title>
            <FontAwesomeIcon icon={faExclamationCircle} className="red mr-2" />
            {t('logout.title')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="ml-3 mr-3">
          <p>{errorCode && t(`errors.${errorCode}`)}</p>
          <div className="d-flex justify-content-center">{children}</div>
        </Modal.Body>
      </Modal>
      {children}
    </div>
  )
}
